import { disableScroll } from '../functions/disable-scroll';
import { enableScroll } from '../functions/enable-scroll';

window.disableScroll = disableScroll
window.enableScroll = enableScroll

export default function filterMobile() {
  const filterMobile = document.querySelector('#filterMobile')
  const filterHeader = document.querySelector('.filter-mobile__header')
  const filterBtn = document.querySelector('.filter-mobile__btn')
  const filterBtnClose = document.querySelector('.filter-mobile__btn-close')
  const filterBtnApply = document.querySelector('.filter-mobile__button--apply')
  const filterBtnClear = document.querySelector('.filter-mobile__button--clear')
  const filterBody = document.querySelector('.filter-mobile__container')
  const PADDING_TOP = 70

  if (!filterHeader) return

  // filterHeader.style.width = filterBtn.offsetWidth + 'px'

  filterBtn.addEventListener('click', () => {
    filterHeader.classList.toggle('active')
    
    if (filterHeader.classList.contains('active')) {
      openFilter()
    }
    else {
      closeFilter()
    }
  })

  filterBtnClose.addEventListener('click', () => {
    filterHeader.classList.remove('active')
    closeFilter()
  })

  filterBtnApply.addEventListener('click', () => {
    filterHeader.classList.remove('active')
    closeFilter()
  })
  
  window.addEventListener('resize', () => {
    if (document.documentElement.clientWidth > 1023) {
      console.log('resize')
      filterHeader.classList.remove('active')
      closeFilter()
    }
  })

  function openFilter() {
    disableScroll()
    // filterHeader.style.width = window.innerWidth + 'px'

    setTimeout(() => {
      filterMobile.classList.add('active')
      // filterBody.classList.add('active')
      // filterBody.style.height = `calc(100vh - ${PADDING_TOP}px - ${filterBtn.offsetHeight}px)`
    }, 350);
  }
  
  function closeFilter() {
    enableScroll()
    filterMobile.classList.remove('active')
    // filterBody.classList.remove('active')
    // filterBody.style.height = '0px'

      setTimeout(() => {
        // filterHeader.style.width = filterBtn.offsetWidth + 'px'
      }, 350);
  }

  filterBtnClear.addEventListener('click', () => {
    clearForm()
  })

  function clearForm() {
    const options = filterMobile.querySelectorAll('option')
    const selected = filterMobile.querySelectorAll('.select__item_selected')
    const inputMin = filterMobile.querySelectorAll('input[name="min-price"]')
    const inputMax = filterMobile.querySelectorAll('input[name="max-price"]')
    options.forEach(option => {
      if(option.selected) {
        option.selected = false
      }
    })
    selected.forEach(select => {
      select.classList.remove('select__item_selected')
    })
    inputMin.forEach(input => {
      input.value = 0
    })
    inputMax.forEach(input => {
      input.value = 4000
    })
  }
}

// export default function filterMobile() {
  
// }